import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { TypicalProjectRoutingModule } from 'src/pages/typical-project-routing.module';
import { ErrorComponent } from 'src/pages/views/error/error.component';
import { PageViewComponent } from 'src/pages/views/page-view/page-view.component';
import { TypicalProjectsRestService } from 'src/services/typical-projects-rest/typical-projects-rest.service';

import { handleNavigationError } from './navigation-error-handler';

@NgModule({
    imports: [
        // Project modules are eagerly loaded because otherwise they would flicker without preloading at the APP_INITIALIZER stage.
        // The order of importing project modules is matter here in terms of routing paths.
        CommonModule,
        TypicalProjectRoutingModule,
        PageViewComponent,
        ErrorComponent,

        RouterModule.forRoot([], {
            enableTracing: false,
            paramsInheritanceStrategy: 'emptyOnly',
            errorHandler: (error) => handleNavigationError(error, inject(Router)),
        }),
    ],
    providers: [TypicalProjectsRestService],
    exports: [RouterModule],
})
export class AppRoutingModule {}
